import {
  Avatar,
  Box,
  Flex,
  Heading,
  Button,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Link,
  Text,
} from "@chakra-ui/react";
import property_image from "../img/property-banner.png";
// import EnvelopeIcon from "../img/icon-mail.png";
// import PhoneIcon from "../img/icon-phone.png";
import { useHistory } from "react-router-dom";
import PhotoGallery from "./PhotoGallery";
import ContactFormButton from "./old-site/ContactForm2";
import {
  CrossIcon,
  EnvelopeIcon,
  LeftArrowIcon,
  PhoneIcon,
  SendIcon,
  ThumbsIcon,
} from "./Icons";
import { formatNumberWithCommas } from "../utils";
import ButtonTheme from "./ButtonTheme";
import {API_BASE_IMAGES} from "../OldApp";

const PropertyBanner = ({ propertyDetail }) => {
  const history = useHistory();

  function getBasename(path) {
    // Use the split() method to split the path by slashes (/ or \)
    const parts = path.split(/[\\/]/);

    // The last part in the resulting array is the basename
    return parts[parts.length - 1];
  }

  const handleGoBack = () => {
    if (getBasename(document.referrer)) history.goBack();
    else window.location.href = "/search";
  };

  return (
    <Flex flexDir={{ lg: "row", base: "column" }} height={"100%"}>
      <Box
        bgImage={
          propertyDetail && propertyDetail.photos
            ? API_BASE_IMAGES + propertyDetail?.photos?.[0]?.path_1400
            : property_image
        }
        bgSize={"cover"}
        flex={{ lg: "1", base: "unset" }}
        maxH={"600px"}
        h={{ lg: "", base: "calc(100vh - 78px)" }}
        textAlign={"end"}
        pos={"relative"}
        bgPos={"center center"}
      >
        <ButtonTheme
          handleButtonClick={handleGoBack}
          chakraProps={{
            leftIcon: <LeftArrowIcon w={6} h={6} mt={4} me={1} />,
            pos: "absolute",
            left: 8,
            top: 8,
            zIndex: 2,
            bgColor: "transparent",
            color: "white",
            w: "auto",
            border: "2px solid white",
            _hover: {
              borderColor: "BrightTurquoise",
              color: "BrightTurquoise",
              ".chakra-icon": {
                path: {
                  fill: "BrightTurquoise",
                },
              },
            },
          }}
          btnText={"Back to Results"}
        />
        {propertyDetail && propertyDetail.photos && (
          <PhotoGallery propertyImages={propertyDetail.photos} />
        )}
      </Box>
      <Box
        p={{ xl: 10, md: 4, base: 10 }}
        bgColor={"DarkBlue"}
        w={{ lg: "30%", base: "100%" }}
      >
        <Heading
          color={"white"}
          mb={4}
          fontSize={{ xl: "2xl", lg: "xl", base: "2xl" }}
        >
          {propertyDetail.externalName || propertyDetail.name}
        </Heading>
        <Text mb={10} color={"white"}>
          {propertyDetail.street_address} <br /> {propertyDetail?.city?.name},{" "}
          {propertyDetail.state_name || propertyDetail.state}
        </Text>
        {propertyDetail && !propertyDetail.available ? (
          ""
        ) : (
          <Flex mb={10} gap={2}>
            <Text color={"white"} fontSize={"sm"}>
              Leasing Agent:
            </Text>
            <Text fontWeight={"600"} color={"white"} fontSize={"sm"}>
              {propertyDetail?.contact_users?.[0]?.first_name}{" "}
              {propertyDetail?.contact_users?.[0]?.last_name}
            </Text>
          </Flex>
        )}
        <Flex mb={8} justifyContent={"space-between"} fontSize={"sm"}>
          <Box textAlign={"center"}>
            <Text color={"BrightTurquoise"} fontWeight={"600"}>
              BUILT
            </Text>
            <Text color={"white"} fontWeight={"400"} fontSize={"sm"}>
              {propertyDetail?.year_built}
            </Text>
          </Box>
          <Box textAlign={"center"}>
            <Text color={"BrightTurquoise"} fontWeight={"600"}>
              FLOORS
            </Text>
            <Text color={"white"} fontWeight={"400"} fontSize={"sm"}>
              {propertyDetail?.number_of_floors}
            </Text>
          </Box>
          <Box textAlign={"center"}>
            <Text color={"BrightTurquoise"} fontWeight={"600"}>
              SIZE SQ FT
            </Text>
            <Text color={"white"} fontWeight={"400"} fontSize={"sm"}>
              {formatNumberWithCommas(propertyDetail?.rba)}
            </Text>
          </Box>
        </Flex>
        <Box
          pe={1}
          h={"140px"}
          overflow={"auto"}
          sx={{
            "::-webkit-scrollbar": {
              width: "6px",
              height: "8px",
            },

            "::-webkit-scrollbar-track": {
              borderRadius: "10px",
              border: "1px solid lightgray",
              bgColor: "lightgray",
              height: "6px",
            },

            "::-webkit-scrollbar-thumb": {
              background: "#999",
              borderRadius: "10px",
            },

            "::-webkit-scrollbar-thumb:hover": {
              background: "#bea432",
            },
          }}
        >
          <Text color={"white"} fontWeight={"400"}>
            {propertyDetail?.description}
          </Text>
        </Box>
        <Flex pt={8} gap={3} alignItems={"center"}>
          {propertyDetail &&
            propertyDetail.contact_users &&
            propertyDetail.contact_users[0] &&
            propertyDetail.contact_users[0].phone && (
              <Link
                flex={1}
                href={"tel:" + propertyDetail.contact_users[0].phone}
                id={"btn_property_banner_phone"}
              >
                <Flex
                  gap={{ xl: 2, base: 1 }}
                  // p={{ xl: 4, base: 3 }}
                  h={"40px"}
                  textAlign={"center"}
                  bgColor={"DarkTeal"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  borderRadius={"full"}
                  w={"100%"}
                >
                  <PhoneIcon w={6} h={6} />
                  <Text color={"white"} fontSize={"xs"}>
                    Call Us
                  </Text>
                </Flex>
              </Link>
            )}
          {propertyDetail &&
            propertyDetail.contact_users &&
            propertyDetail.contact_users[0] &&
            propertyDetail.contact_users[0].email && (
              <ContactFormButton property={propertyDetail}>
                {({ showModal }) => (
                  <Button
                    className="contactButton bk-button"
                    onClick={showModal}
                    fontWeight={"400"}
                    h={"40px"}
                    w={"50%"}
                    borderRadius={"30px"}
                    bgColor={"DarkTeal !important"}
                    textTransform={"math-auto"}
                    fontSize={"xs"}
                    border={"0 !important"}
                    id="btn_interested_make_an_inquiry"
                  >
                    <EnvelopeIcon w={6} h={6} me={2} />
                    Make an Inquiry
                  </Button>
                )}
              </ContactFormButton>
            )}

          {/* {propertyDetail && propertyDetail.photos && (<PhotoGallery propertyImages={propertyDetail.photos} />)} */}

          {/* <Box
            textAlign={"center"}
            bgColor={"DarkTeal"}
            w={"48px"}
            h={"48px"}
            lineHeight={"48px"}
            borderRadius={"full"}
          >
            <ThumbsIcon w={6} h={6} />
          </Box> */}
        </Flex>
      </Box>
    </Flex>
  );
};

export default PropertyBanner;
